import { defineStore } from 'pinia';
import dayjs from 'dayjs';
import type { AddIndividualAccountBody } from '~/types';
import { useSettingsFormStore } from './settings-form-store';

export const useIndividualFormStore = defineStore('account-individual-form', {
  state: () => ({
    firstName: {
      value: undefined as string | undefined,
      isValid: undefined as boolean | undefined
    },
    lastName: {
      value: undefined as string | undefined,
      isValid: undefined as boolean | undefined
    },
    birthDate: {
      value: undefined as string | undefined,
      isValid: undefined as boolean | undefined
    },
    birthCountry: undefined as string | undefined,
    residenceCountry: undefined as string | undefined,
    nationalities: [] as Array<string>,
    email: {
      value: '' as string,
      isValid: undefined as boolean | undefined
    }
  }),

  getters: {
    addIndividualAccountBody(): AddIndividualAccountBody {
      const { profile, walletId, activityType } = useSettingsFormStore();

      return {
        individual: {
          firstName: this.firstName.value,
          lastName: this.lastName.value,
          email: this.email.value,
          birthDate: dayjs(this.birthDate.value, 'DD/MM/YYYY').format('YYYY-MM-DD'),
          birthCountry: this.residenceCountry,
          nationalities: this.nationalities,
          address: {
            country: this.residenceCountry
          }
        },
        profile,
        walletId: walletId.value,
        activity: activityType
      };
    }
  },

  actions: {
    validateForm(): boolean {
      return (this.firstName.isValid &&
        this.lastName.isValid &&
        this.birthDate.isValid &&
        this.birthCountry &&
        this.residenceCountry &&
        this.nationalities.length > 0 &&
        this.email.isValid) as boolean;
    }
  }
});
